import { Link } from "react-router-dom";

export default function Contact1() {
    return (
        <>
            <section id="contact" className="contact-1-section pt-lg-0">
                <div className="auto-container">
                    <div className="row align-items-center">                
                        <div className="col-lg-6 order-lg-2">
                            <div className="section_heading mb_60">
                                <span className="section_heading_title_small">Appointment</span>
                                <h2 className="section_heading_title_big">Want to Hear More About <br /> Sha Care Hospice?</h2>
                            </div>
                            <div className="contact-form">
                                <form method="post" action="/" id="contact-form">
                                    <div className="row clearfix">
                                        <div className="form-group col-md-6">
                                            <input type="text" name="form_name"  placeholder="Your Name" required />
                                        </div>
                                        
                                        <div className="form-group col-md-6">
                                            <input type="text" name="email" placeholder="Your Email" required />
                                        </div>
                                        
                                        <div className="form-group col-md-12">
                                            <input type="text" name="form_subject" placeholder="Subject" required />
                                        </div>
                                        
                                        <div className="form-group col-md-12">
                                            <textarea name="form_message" placeholder="Message"></textarea>
                                        </div>
                                        
                                        <div className="form-group col-md-12">
                                            <input id="form_botcheck" name="form_botcheck" className="form-control" type="hidden" value="4" />
                                            <button className="btn-1 btn-small" type="submit" data-loading-text="Please wait...">Submit now <i className="flaticon-right-arrow-1"></i><span></span></button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="col-lg-6 d-flex" style={{ height: '100vh' }}>
                            <div className="contact-map-banner w-100" style={{ flex: 1 }}>
                                <div className="gmap_canvas" style={{ width: '100%', height: '100%' }}>
                                    <iframe
                                        className="gmap_iframe"
                                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d216440.17462835845!2d115.80044038855931!3d-32.04550086141406!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2a32bd65aed4c6e7%3A0x515c6f66f76c5ce0!2s2%20Atkinson%20Gardens%2C%20Leeming%20WA%206149%2C%20Australia!5e0!3m2!1sen!2slk!4v1746363307594!5m2!1sen!2slk"
                                        style={{ border: 0, width: '100%', height: '100%' }}
                                        allowFullScreen=""
                                        loading="lazy"
                                    ></iframe>




                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
